import { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Users, UserPlus } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'

import { defaultPeriodValue } from './utils'
import PeriodSelect from './PeriodSelect'
import AnalyticsItem from './AnalyticsItem'
import { useAnalytics } from './useAnalytics'

const VisitorsAnalytics = ({ selectedBuilding }) => {
  const { t } = useTranslation(['visitors'])
  const [selectedPeriod, setSelectedPeriod] = useState(defaultPeriodValue)

  const { data, isLoading } = useAnalytics(selectedBuilding.id, selectedPeriod)

  return (
    <div className="ctp-survey__box visitor-analytics">
      <PeriodSelect
        disabled={isLoading}
        selectedDate={selectedPeriod}
        onSelect={setSelectedPeriod}
      />
      <AnalyticsItem
        icon={<Users />}
        title={t('visitors:analytics.totalAuthorizedVisitors')}
        count={data ? data.visitors : undefined}
        isLoading={isLoading}
      />
      <AnalyticsItem
        icon={<UserPlus />}
        title={t('visitors:analytics.checkIns')}
        count={data ? data.checkIns : undefined}
        isLoading={isLoading}
      />
    </div>
  )
}

VisitorsAnalytics.propTypes = {
  selectedBuilding: PropTypes.object,
}

export default connect((state) => {
  return {
    selectedBuilding: selectActiveBuilding(state),
  }
})(VisitorsAnalytics)
